export default [
    ['Contactless Debit Mastercard', '£3.95', 'FREE', 'FREE'],
    ['BACS Direct Debit', 'FREE', 'FREE', 'FREE'],
    [
        'Sending faster payments',
        '<strong>1%</strong><br/>&pound;2.00<br/>cap',
        'FREE',
        'FREE'
    ],
    [
        'ATM cash withdrawal',
        '<strong>2%</strong><br/>&pound;4.50<br/>cap',
        'FREE',
        'FREE'
    ],
    [
        'Non-UK ATM cash withdrawal ',
        '<strong>2%</strong><br/>&pound;4.50<br/>cap',
        'FREE',
        'FREE'
    ],
    [
        'Post Office cash withdrawal ',
        '<strong>2%</strong><br/>&pound;5.00<br/>cap',
        'FREE',
        'FREE'
    ],
    [
        'Post Office cash deposit ',
        '<strong>2%</strong><br/>&pound;10.00<br/>cap',
        'FREE',
        'FREE'
    ],
    ['Lost or damaged card', '&pound;4.95', '&pound;4.95', '&pound;4.95'],
    ['Paper statement', 'FREE', 'FREE', 'FREE'],
    [
        '<strong>Premium features</strong>',
        '<strong>Everyday</strong>',
        '<strong>Smart</strong>',
        '<strong>SmartPlus</strong>'
    ],
    // [
    //     'Cashback when you shop',
    //     'icon--check',
    //     'icon--check',
    //     'icon--check'
    // ],
    [
        'Auto budget for your bills',
        'bgColor',
        'icon--check',
        'icon--check'
    ],
    [
        'All your bills paid on time',
        'bgColor',
        'icon--check',
        'icon--check'
    ],
    [
        'Exclusive discounts and rewards',
        'bgColor',
        'bgColor',
        'icon--check'
    ]
];
